import { defineStore } from "pinia";

export interface Pagination {
  currentPage: number;
  itemsPerPage: number;
  totalPages: number;
  totalItems: number;
}

export const usePagination = defineStore("pagination", {
  state: () => {
    return {
      pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      } as Pagination,
    };
  },
  actions: {
    calculateTotalPages(totalItems: number) {
      this.pagination.totalItems = totalItems;
      this.pagination.totalPages = Math.ceil(totalItems / this.pagination.itemsPerPage);
    },
    resetPagination() {
      this.pagination.currentPage = 1;
      this.pagination.itemsPerPage = 10;
      this.pagination.totalPages = 1;
      this.pagination.totalItems = 0;
    },
  },
  getters: {},
});
